<template>
    <div v-show="active" :style="background" class="progress">
        <div>
            <div v-if="indeterminate" :style="{ 'background-color': colors.progress.fg }" class="indeterminate" />
            <div
                v-else
                :style="{
                    width: normalizedValue,
                    'background-color': colors.progress.fg,
                }"
                class="determinate"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChatProgress',

    props: {
        active: {
            type: Boolean,
            default: false,
        },
        colors: {
            type: Object,
            required: true,
        },
        height: {
            type: Number,
            default: 4,
        },
        indeterminate: {
            type: Boolean,
            default: true,
        },
        value: {
            type: Number,
            default: 0,
        },
    },

    computed: {
        normalizedValue() {
            if (this.value < 0) {
                return 0;
            }

            if (this.value > 100) {
                return 100;
            }

            return parseFloat(this.value);
        },

        background() {
            const style = { height: `${this.height}px` };

            if (this.active) {
                style['background-color'] = this.colors.bg;
            }

            return style;
        },
    },
};
</script>

<style lang="scss" scoped>
// CHAT
// Keyframes
@mixin keyframes($animation-name) {
    @-webkit-keyframes #{$animation-name} {
        @content;
    }
    @-moz-keyframes #{$animation-name} {
        @content;
    }
    @keyframes #{$animation-name} {
        @content;
    }
}

// Progress Bar
.progress {
    position: relative;
    display: block;
    width: 100%;
    border-radius: 2px;
    background-clip: padding-box;
    overflow: hidden;
    margin-bottom: 0 !important;

    .determinate {
        position: absolute;
        top: 0;
        bottom: 0;
        transition: width 0.3s linear;
    }

    .indeterminate {
        &:before {
            content: '';
            position: absolute;
            background-color: inherit;
            top: 0;
            left: 0;
            bottom: 0;
            will-change: left, right;
            // Custom bezier
            animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
        }
        &:after {
            content: '';
            position: absolute;
            background-color: inherit;
            top: 0;
            left: 0;
            bottom: 0;
            will-change: left, right;
            // Custom bezier
            animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
            animation-delay: 1.15s;
        }
    }
}

@include keyframes(indeterminate) {
    0% {
        left: -35%;
        right: 100%;
    }
    60% {
        left: 100%;
        right: -90%;
    }
    100% {
        left: 100%;
        right: -90%;
    }
}

@include keyframes(indeterminate-short) {
    0% {
        left: -200%;
        right: 100%;
    }
    60% {
        left: 107%;
        right: -8%;
    }
    100% {
        left: 107%;
        right: -8%;
    }
}
</style>
